
import Vue from "vue";
import CrmHistory from "@/models/crm/crm-history";
import CrmHistoryCall from "@/models/crm/crm-history-call";
import { Contact } from "@/models/base";
import { getContactServiceByGroupId } from "@/utils/services/contact-services";

export default Vue.extend({
	data() {
		return {
			props: new CrmHistoryCall(),
			text: "",
			phoneSource: "other",
			savingPhone: false
		};
	},
	props: {
		value: {
			required: true,
			type: Object as () => CrmHistory
		},
		contact: {
			required: true,
			type: Object as () => Contact,
		},
	},
	computed: {
		contactPhone():string {
			return (this.contact.MainAddress?.Phone || "").trim();
		},
		contactMobile():string {
			return (this.contact.MainAddress?.Mobile || "").trim();
		},
		phoneSourceItems():any[] {
			let items = [] as any[];
			if (this.contactPhone) {
				items.push({text: `${this.$ct("labels.phone-fixed")} (${this.contactPhone})`, value: "phone"});
			}
			if (this.contactMobile) {
				items.push({text: `${this.$ct("labels.phone-mobile")} (${this.contactMobile})`, value: "mobile"});
			}
			items.push({text: this.$ct("labels.phone-other"), value: "other"});
			return items;
		},
		savePhoneItems():any[] {
			return [
				{text: this.$ct("labels.save-phone-as-phone"), value: "phone"},
				{text: this.$ct("labels.save-phone-as-mobile"), value: "mobile"}
			];
		},
		canSavePhone():boolean {
			return this.contact.ID != 0 && this.contact.MainAddress != null && ((this.value.Props as any).Phone || "").trim() != "";
		}
	},
	watch: {
		value: {
			immediate: true,
			handler() {
				this.text = (this.value.Props as any).Message;
			}
		}
	},
	methods: {
		onInput(value: string){
			let regex = /style="(.*?)"/gm;
			value = value.replace(regex, "");
			this.text = value;
			(this.value.Props as any).Message = value;
			this.$emit("input",this.value);
		},
		setPhoneSource(source:string){
			this.phoneSource = source;
			let phone = "";
			if (source == "phone") {
				phone = this.contactPhone;
			} else if (source == "mobile") {
				phone = this.contactMobile;
			}
			this.value.Props = {...this.value.Props, Phone: phone};
		},
		async savePhone(target:string){
			if (this.savingPhone) return;
			this.savingPhone = true;
			try {
				let phone = ((this.value.Props as any).Phone || "").trim();
				let service = getContactServiceByGroupId(this.contact.GroupID);
				let contact = await service.getContact(this.contact.ID);
				if (contact.MainAddress == null) return;
				if (target == "phone") {
					contact.MainAddress.Phone = phone;
				} else {
					contact.MainAddress.Mobile = phone;
				}
				await service.putContact(contact);
				if (this.contact.MainAddress != null) {
					if (target == "phone") {
						this.contact.MainAddress.Phone = phone;
					} else {
						this.contact.MainAddress.Mobile = phone;
					}
				}
				this.phoneSource = target;
			} finally {
				this.savingPhone = false;
			}
		},
		initPhoneSource(){
			let phone = ((this.value.Props as any).Phone || "").trim();
			if (phone == "") {
				if (this.contactPhone) {
					this.setPhoneSource("phone");
				} else if (this.contactMobile) {
					this.setPhoneSource("mobile");
				} else {
					this.phoneSource = "other";
				}
			} else if (phone == this.contactPhone) {
				this.phoneSource = "phone";
			} else if (phone == this.contactMobile) {
				this.phoneSource = "mobile";
			} else {
				this.phoneSource = "other";
			}
		}
	},
	created(){

		if(!("Contact" in this.value.Props)){
			if(this.contact.MainAddress !== null){
				this.value.Props = {...this.value.Props, Contact: this.contact.MainAddress.FirstName };
			}
		}
		if(!("Phone" in this.value.Props)){
			this.value.Props = {...this.value.Props, Phone: "" };
		}
		this.initPhoneSource();
	},
	components: {

	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
